import Vue from 'vue'

/** Les demandes de retrait de consentement : la file de ZEborne, et sa décision. */
class ConsentWithdrawalRepository {

  // GET /api/consents/withdrawal-requests[?decided=1] — en GET, les paramètres passent par `data`
  list(decided = false) {
    return this.fetch({ url: '/api/consents/withdrawal-requests', method: 'get', data: decided ? { decided: 1 } : {} })
  }

  // POST /api/consents/{id}/withdrawal-decision { accept, reason }
  decide(consentId, accept, reason = null) {
    return this.fetch({ url: `/api/consents/${consentId}/withdrawal-decision`, method: 'post', data: { accept, reason } })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new ConsentWithdrawalRepository()
